import { Card, CardContent, CardHeader, Grid, Typography } from '@mui/material';
import React from 'react';
import { ReactNode } from 'react';

interface Props {
  title: string;
  children?: ReactNode;
}

export const ReportingBatchReportCard = (props: Props) => {
  return (
    <Grid item>
      <Card elevation={3}>
        <CardHeader title={<Typography variant="h4">{props.title}</Typography>} />
        <CardContent>
          <Grid container direction="column" spacing={1}>
            {props.children}
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};
